export default __webpack_public_path__ + "static/poster-1885fb54813b79275f3f9a7d8fd65b2b.png";